import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./Login.module.scss";

const LoginShell = () => {
  const location = useLocation();

  return (
    <div className={styles.shell}>
      <aside className={styles.brand}>
        <div className={styles.brand_glow} aria-hidden="true" />
        <div className={styles.brand_content}>
          <p className={styles.brand_name}>AIAVANTRA</p>
          <h1 className={styles.brand_title}>Partner login</h1>
          <p className={styles.brand_copy}>
            Secure access to your hospital operations console. Manage
            appointments, care teams, inventory, and patient workflows from one
            place.
          </p>
        </div>
        <p className={styles.brand_footer}>
          Healthcare operations, simplified.
        </p>
      </aside>

      <main className={styles.panel}>
        <div key={location.pathname} className={styles.form_stage}>
          <div className={styles.form_wrap}>
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginShell;
